import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=10f937d4&"
import script from "./userEdit.vue?vue&type=script&lang=js&"
export * from "./userEdit.vue?vue&type=script&lang=js&"
import style0 from "./userEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports